import { FormikProps } from 'formik'

import { FormErrors, useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

import useCreateReimbursableSupplementMapping from 'modules/payroll_bundle/hooks/useCreateReimbursableSupplementMapping'

export interface TaxonomyForm {
  supplementTaxonomyId: string
  legalEntityId: string
  timeRangeCategoryId: string
}

const MapTimeBlockTaxonomyForm = (legalEntityId: string) => {
  const { create: createMapping } = useCreateReimbursableSupplementMapping()

  const defaultValues: TaxonomyForm = {
    supplementTaxonomyId: '',
    legalEntityId: legalEntityId,
    timeRangeCategoryId: '',
  }

  const form: FormikProps<TaxonomyForm> = useForm({
    defaultValues: defaultValues,
    validate: (data) => {
      const errors: FormErrors<TaxonomyForm> = {}

      if (!data.supplementTaxonomyId || data.supplementTaxonomyId === '') {
        errors.supplementTaxonomyId = i18n.t('clock_in.sidepanel.compensation.modal.taxonomy.empty')
      }

      return errors
    },
    onSubmit: async (data, { setErrors }) => {
      const response = await createMapping({
        legalEntityId: data.legalEntityId.toString(),
        reimbursableId: data.timeRangeCategoryId.toString(),
        reimbursableType: 'TimeSettings::CustomTimeRangeCategory',
        supplementTaxonomyId: data.supplementTaxonomyId,
      })

      const handled = handleResult(response, ({ supplementTaxonomyId }) => {
        setErrors({ supplementTaxonomyId })
      })

      form.resetForm()
      return handled
    },
  })

  return form
}

export default MapTimeBlockTaxonomyForm
